export default "__VITE_ASSET__Dma84kDp__"